import React, { FC, useEffect, useRef } from 'react';
import { Route, Routes } from 'react-router-dom';
import '@wix/design-system/styles.global.css';

import TemplatesPageNew from '../TemplatesPageNew/TemplatesPage';
import { appRoutes } from '../../routes';
import { BiLoggerProvider } from '../../contexts/BILoggerContext';
import { useFedopsLogger } from '../../contexts/FedopsLoggerContext';
import { HtmlHead } from '../HtmlHead/HtmlHead';
import { SidePanel } from '../SidePanel/SidePanel';
import { NewFooter } from '../NewFooter/NewFooter';
import { SubHeader } from '../SubHeader/SubHeader';

import s from './App.scss';

const App: FC = () => {
  const topRef = useRef<HTMLDivElement>(null);
  const fedopsLogger = useFedopsLogger();

  useEffect(() => {
    fedopsLogger.reportAppLoaded();
  }, []);

  const onScrollTop = () => topRef.current?.scrollIntoView(true);

  return (
    <div className={s.root}>
      <SubHeader />
      <div ref={topRef} className={s.topTarget} />
      <div className={s.content}>
        <Routes>
          <Route
            path={appRoutes.templates.pattern}
            element={
              <BiLoggerProvider>
                <SidePanel onScrollTop={onScrollTop} />
                <HtmlHead />
                <TemplatesPageNew />
              </BiLoggerProvider>
            }
          />
        </Routes>
      </div>
      <NewFooter />
    </div>
  );
};

export default App;
